// removed by extract-text-webpack-plugin
module.exports = {"assignment":"assignment_1m1kG","sidebar":"sidebar_2h4dz","instructions":"instructions_Ub7ei","close":"close_32-ee","selectFilesButton":"selectFilesButton_zn6qG","picker":"picker_18Xvr","noPhotos":"noPhotos_37typ","help":"help_2DsCT","header":"header_2aHOk","tip":"tip_2JneU","tabs":"tabs_3IEHo","active":"active_1eEOb","upload":"upload_1EJ8r","message":"message_1fed5","photos":"photos_6_oMN","photo":"photo_2zNRj","buttonFill":"buttonFill_30b3z"};


//////////////////
// WEBPACK FOOTER
// ./app/components/assignment/styles.scss
// module id = 413
// module chunks = 1